module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            Kartu Piutang\n        ")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Ketik Marking",
      "filterable": "",
      "clearable": "",
      "remote": "",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.loadingGetMarking
    },
    on: {
      "on-change": function($event) {
        return _vm.setMarkingCode()
      }
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                " + _vm._s(option.label) + "\n              ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [(_vm.topColor) ? _c('div', {
    style: ({
      width: '25px',
      height: '25px',
      borderRadius: '50%',
      backgroundColor: _vm.topColor,
      border: '1px solid #ccc'
    })
  }) : _vm._e()]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingGetReceivable),
      expression: "loadingGetReceivable"
    }],
    attrs: {
      "size": "large"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.historyDeleteClaim.length > 0 && _vm.markingIdSelected) ? _c('Collapse', {
    on: {
      "on-change": _vm.onCollapseChange
    },
    model: {
      value: (_vm.activeCollapseNames),
      callback: function($$v) {
        _vm.activeCollapseNames = $$v
      },
      expression: "activeCollapseNames"
    }
  }, [_c('Panel', {
    attrs: {
      "name": "1"
    }
  }, [_vm._v("\n                History Hapus Klaim\n                "), (_vm.historyDeleteClaim.length > 0) ? _c('Table', {
    attrs: {
      "slot": "content",
      "columns": _vm.tableHistoryColumns,
      "data": _vm.historyDeleteClaim
    },
    slot: "content"
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.receivables.length > 0 || _vm.isSupervisor()) && _vm.markingIdSelected),
      expression: "(receivables.length > 0 || isSupervisor()) && markingIdSelected"
    }]
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }), _vm._v(" "), _c('template', {
    slot: "extra"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canCreateReceivable()),
      expression: "canCreateReceivable()"
    }],
    attrs: {
      "type": "success",
      "icon": "plus-round",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.modal.createReceivable = true
      }
    }
  }, [_vm._v("\n                    Tambah Piutang\n                ")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowRateAdjustment),
      expression: "isShowRateAdjustment"
    }],
    attrs: {
      "type": "warning",
      "icon": "ios-gear",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.modal.createRateAdjustment = true
      }
    }
  }, [_vm._v("\n                    Penyesuaian Rate\n                ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.topColor),
      expression: "topColor"
    }]
  }, [_c('Alert', {
    class: _vm.alertClass,
    attrs: {
      "type": _vm.alertType,
      "show-icon": ""
    }
  }, [_vm._v("\n                Term Of Payment\n              ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositRemaining > 0),
      expression: "depositRemaining > 0"
    }]
  }, [_c('Alert', {
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("Deposit = " + _vm._s(_vm._f("currency")(_vm.depositRemaining)))]), _vm._v(" "), _c('Alert', {
    attrs: {
      "show-icon": ""
    }
  }, [_vm._v("Balance - Deposit = " + _vm._s(_vm._f("currency")((_vm.countBalance - _vm.depositRemaining))))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositMutasiRemaining > 0),
      expression: "depositMutasiRemaining > 0"
    }]
  }, [_c('Alert', {
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("Deposit Mutasi = " + _vm._s(_vm._f("currency")(_vm.depositMutasiRemaining)))])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "row-class-name": _vm.rowClassName,
      "columns": _vm.tableColumns,
      "data": _vm.receivables,
      "no-data-text": ""
    },
    on: {
      "on-row-click": _vm.handleRowClick
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "Edit Currency Rate",
      "width": "600",
      "mask-closable": false
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('Form', {
    ref: "rateForm",
    attrs: {
      "model": _vm.formRate,
      "label-position": "left",
      "label-width": 140
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "Description",
      "prop": "description"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.formRate.realDescription)
    }
  })]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Debit",
      "prop": "debit"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formRate.debit),
      callback: function($$v) {
        _vm.$set(_vm.formRate, "debit", $$v)
      },
      expression: "formRate.debit"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Credit",
      "prop": "credit"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formRate.credit),
      callback: function($$v) {
        _vm.$set(_vm.formRate, "credit", $$v)
      },
      expression: "formRate.credit"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Rate",
      "prop": "rate"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.formRate.rate),
      callback: function($$v) {
        _vm.$set(_vm.formRate, "rate", $$v)
      },
      expression: "formRate.rate"
    }
  }, 'money', _vm.moneyFloat, false))], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Receivable Date",
      "prop": "receivable_date"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "readonly": ""
    },
    model: {
      value: (_vm.formRate.receivable_date),
      callback: function($$v) {
        _vm.$set(_vm.formRate, "receivable_date", $$v)
      },
      expression: "formRate.receivable_date"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.role === 'ADMINISTRATOR'),
      expression: "user.role === 'ADMINISTRATOR'"
    }],
    attrs: {
      "label": "Settle Date",
      "prop": "settle_date"
    }
  }, [_c('Date-picker', {
    model: {
      value: (_vm.formRate.settle_date),
      callback: function($$v) {
        _vm.$set(_vm.formRate, "settle_date", $$v)
      },
      expression: "formRate.settle_date"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.role === 'ADMINISTRATOR'),
      expression: "user.role === 'ADMINISTRATOR'"
    }],
    attrs: {
      "label": "Payment Sum",
      "prop": "payment_sum"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formRate.payment_sum),
      callback: function($$v) {
        _vm.$set(_vm.formRate, "payment_sum", $$v)
      },
      expression: "formRate.payment_sum"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.role === 'ADMINISTRATOR'),
      expression: "user.role === 'ADMINISTRATOR'"
    }]
  }, [_c('Button', {
    attrs: {
      "type": "error",
      "icon": "ios-trash",
      "disabled": _vm.user.role !== 'ADMINISTRATOR'
    },
    on: {
      "click": function($event) {
        return _vm.confirmDelete(_vm.formRate.receivable_id)
      }
    }
  }, [_vm._v("\n                    Delete\n                  ")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitRate
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "Edit Description",
      "width": "70%",
      "mask-closable": false
    },
    model: {
      value: (_vm.showModalDesc),
      callback: function($$v) {
        _vm.showModalDesc = $$v
      },
      expression: "showModalDesc"
    }
  }, [_c('Form', {
    ref: "rateForm",
    attrs: {
      "model": _vm.formRate,
      "label-position": "left",
      "label-width": 140
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "Receivable Date",
      "prop": "receivable_date"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "readonly": ""
    },
    model: {
      value: (_vm.formRate.receivable_date),
      callback: function($$v) {
        _vm.$set(_vm.formRate, "receivable_date", $$v)
      },
      expression: "formRate.receivable_date"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Description",
      "prop": "description"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formRate.realDescription),
      callback: function($$v) {
        _vm.$set(_vm.formRate, "realDescription", $$v)
      },
      expression: "formRate.realDescription"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Debit",
      "prop": "debit"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formRate.debit),
      callback: function($$v) {
        _vm.$set(_vm.formRate, "debit", $$v)
      },
      expression: "formRate.debit"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Credit",
      "prop": "credit"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formRate.credit),
      callback: function($$v) {
        _vm.$set(_vm.formRate, "credit", $$v)
      },
      expression: "formRate.credit"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.role === 'ADMINISTRATOR'),
      expression: "user.role === 'ADMINISTRATOR'"
    }],
    attrs: {
      "label": "Settle Date",
      "prop": "settle_date"
    }
  }, [_c('Date-picker', {
    model: {
      value: (_vm.formRate.settle_date),
      callback: function($$v) {
        _vm.$set(_vm.formRate, "settle_date", $$v)
      },
      expression: "formRate.settle_date"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.role === 'ADMINISTRATOR'),
      expression: "user.role === 'ADMINISTRATOR'"
    }],
    attrs: {
      "label": "Payment Sum",
      "prop": "payment_sum"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formRate.payment_sum),
      callback: function($$v) {
        _vm.$set(_vm.formRate, "payment_sum", $$v)
      },
      expression: "formRate.payment_sum"
    }
  })], 1)], 1), _vm._v(" "), _c('Table', {
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      "size": "small",
      "columns": _vm.paymentDetail,
      "data": _vm.paymentData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v("History:")]), _vm._v(" "), _c('Table', {
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      "size": "small",
      "columns": _vm.columnsPreview,
      "data": _vm.historyData
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showModalDesc = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitEditReceivable
    }
  }, [_vm._v("Save")])], 1)], 1)], 2)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    on: {
      "on-cancel": function($event) {
        return _vm.clearCreateReceivable()
      }
    },
    model: {
      value: (_vm.modal.createReceivable),
      callback: function($$v) {
        _vm.$set(_vm.modal, "createReceivable", $$v)
      },
      expression: "modal.createReceivable"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Tambah Piutang")])], 1), _vm._v(" "), _c('Form', {
    ref: "createReceivableForm",
    attrs: {
      "model": _vm.createReceivable,
      "rules": _vm.createReceivableRule,
      "label-width": 120
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Tgl Transaksi",
      "prop": "transactionDate"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Pilih Tanggal",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.createReceivable.transactionDate),
      callback: function($$v) {
        _vm.$set(_vm.createReceivable, "transactionDate", $$v)
      },
      expression: "createReceivable.transactionDate"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": "Keterangan",
      "prop": "description"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.createReceivable.description),
      callback: function($$v) {
        _vm.$set(_vm.createReceivable, "description", $$v)
      },
      expression: "createReceivable.description"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": "Jumlah"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "prop": "amount"
    },
    model: {
      value: (_vm.createReceivable.amount),
      callback: function($$v) {
        _vm.$set(_vm.createReceivable, "amount", $$v)
      },
      expression: "createReceivable.amount"
    }
  }, 'money', _vm.isShowRateAdjustment ? _vm.moneyFloat : _vm.money, false))], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Upload File",
      "prop": "filename"
    }
  }, [_c('br'), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.createReceivable.imageUploaded),
      expression: "createReceivable.imageUploaded"
    }],
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": _vm.createReceivable.imageUploaded,
      "alt": "Uploaded Image"
    }
  }), _vm._v(" "), _c('Upload', {
    ref: "upload",
    attrs: {
      "type": "drag",
      "name": "fileUploaded",
      "action": this.serverUrlUploadFile,
      "before-upload": _vm.handleBeforeUpload,
      "accept": "image/*"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click or drag files here to upload")])], 1)]), _vm._v(" "), _c('Progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProgress),
      expression: "isProgress"
    }],
    attrs: {
      "percent": _vm.pValue,
      "stroke-width": 20
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingCreateReceivable
    },
    on: {
      "click": _vm.validateAndCreateReceivable
    }
  }, [(!_vm.loadingCreateReceivable) ? _c('span', [_vm._v("Simpan")]) : _c('span', [_vm._v("Wait.....")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    on: {
      "on-cancel": function($event) {
        return _vm.clearCreateReceivableDeposit()
      }
    },
    model: {
      value: (_vm.modal.createReceivableDeposit),
      callback: function($$v) {
        _vm.$set(_vm.modal, "createReceivableDeposit", $$v)
      },
      expression: "modal.createReceivableDeposit"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Tambah Deposit")])], 1), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 120
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Tgl Transaksi"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "type": "date",
      "placeholder": "",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.createReceivableDeposit.transactionDate),
      callback: function($$v) {
        _vm.$set(_vm.createReceivableDeposit, "transactionDate", $$v)
      },
      expression: "createReceivableDeposit.transactionDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_vm._v(" \n                    ")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.createReceivableDeposit.description),
      callback: function($$v) {
        _vm.$set(_vm.createReceivableDeposit, "description", $$v)
      },
      expression: "createReceivableDeposit.description"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": "Jumlah"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.createReceivableDeposit.amount),
      callback: function($$v) {
        _vm.$set(_vm.createReceivableDeposit, "amount", $$v)
      },
      expression: "createReceivableDeposit.amount"
    }
  }, 'money', _vm.money, false))], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingCreateReceivableDeposit
    },
    on: {
      "click": _vm.postCreateReceivableDeposit
    }
  }, [(!_vm.loadingCreateReceivableDeposit) ? _c('span', [_vm._v("Simpan")]) : _c('span', [_vm._v("Wait.....")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "80%"
    },
    model: {
      value: (_vm.modal.createPayment),
      callback: function($$v) {
        _vm.$set(_vm.modal, "createPayment", $$v)
      },
      expression: "modal.createPayment"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Payment set")])], 1), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 120
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Tgl Pembayaran"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    on: {
      "on-change": _vm.checkButtonSave
    },
    model: {
      value: (_vm.createPaymentPending.paymentDate),
      callback: function($$v) {
        _vm.$set(_vm.createPaymentPending, "paymentDate", $$v)
      },
      expression: "createPaymentPending.paymentDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Marking"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "Marking"
    },
    model: {
      value: (_vm.createPaymentPending.selectedMarkingLabel),
      callback: function($$v) {
        _vm.$set(_vm.createPaymentPending, "selectedMarkingLabel", $$v)
      },
      expression: "createPaymentPending.selectedMarkingLabel"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "250px"
    },
    on: {
      "on-change": _vm.checkButtonSave
    },
    model: {
      value: (_vm.createPaymentPending.description),
      callback: function($$v) {
        _vm.$set(_vm.createPaymentPending, "description", $$v)
      },
      expression: "createPaymentPending.description"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Deposito Mutasi"
    }
  }, [_c('Alert', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.createPaymentPending.mutasiRemainingPayment)) + "\n                ")]), _vm._v(" "), (_vm.createPaymentPending.totalUseDepositAmount > 0 && _vm.createPaymentPending.totalUseDepositAmount > _vm.createPaymentPending.mutasiRemainingPayment) ? _c('font', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                    Terpakai\n                    " + _vm._s(_vm._f("currency")(_vm.createPaymentPending.totalUseDepositAmount)) + " - LEBIH")]) : _vm._e(), _vm._v(" "), (_vm.createPaymentPending.totalUseDepositAmount > 0 && _vm.createPaymentPending.totalUseDepositAmount <= _vm.createPaymentPending.depositRemainingPayment) ? _c('font', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                    Terpakai: " + _vm._s(_vm._f("currency")(_vm.createPaymentPending.totalUseDepositAmount)) + ", Sisa: " + _vm._s(_vm._f("currency")((_vm.createPaymentPending.depositRemainingPayment -
    _vm.createPaymentPending.totalUseDepositAmount))) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Uang Diterima"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.createPaymentPending.amountReceived),
      callback: function($$v) {
        _vm.$set(_vm.createPaymentPending, "amountReceived", $$v)
      },
      expression: "createPaymentPending.amountReceived"
    }
  }, 'money', _vm.money, false)), _vm._v(" "), _c('font', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.createPaymentPending.amountResidue != 0),
      expression: "createPaymentPending.amountResidue != 0"
    }],
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("\n                    Selisih   " + _vm._s(_vm._f("currency")(_vm.createPaymentPending.amountResidue)) + "\n                ")])], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.invoiceDues.length > 0),
      expression: "this.invoiceDues.length > 0"
    }]
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n                Daftar Invoice\n            ")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg ivu-row-flex-space-between",
    attrs: {
      "type": "flex"
    }
  }, [
    [_c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_vm._v("\n                    Tgl Bongkar\n                    ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "8"
      }
    }, [_vm._v("\n                    Keterangan\n                    ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_vm._v("\n                    Total\n                    ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "1"
      }
    }), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_vm._v("\n                    Sisa\n                    ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "1"
      }
    }), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "5"
      }
    }, [_vm._v("\n                    Alokasi Pembayaran\n                    ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "1"
      }
    })]
  ], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.invoiceDues), function(invoiceDue) {
    return _c('div', [_c('cInvoicePaymentMutasi', {
      attrs: {
        "invoiceDue": invoiceDue,
        "depositRemaining": _vm.createPaymentPending.depositRemainingPayment,
        "paymentPendingId": _vm.createPaymentPending.paymentPendingId,
        "paymentPendingAmount": _vm.createPaymentPending.paymentPendingAmount
      },
      on: {
        "setAllocateAmount": _vm.setAllocateAmount
      }
    }), _vm._v(" "), _c('br')], 1)
  })], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isButtonSave),
      expression: "isButtonSave"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingCreateReceivable
    },
    on: {
      "click": _vm.postPayment
    }
  }, [(!_vm.loadingCreateReceivable) ? _c('span', [_vm._v("Simpan")]) : _c('span', [_vm._v("Wait.....")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    on: {
      "on-cancel": function($event) {
        return _vm.clearCreateRateAdjustment()
      }
    },
    model: {
      value: (_vm.modal.createRateAdjustment),
      callback: function($$v) {
        _vm.$set(_vm.modal, "createRateAdjustment", $$v)
      },
      expression: "modal.createRateAdjustment"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f90",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Penyesuaian Rate")])], 1), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 120
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Tgl Transaksi"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "type": "date",
      "placeholder": "",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.createRateAdjustment.transactionDate),
      callback: function($$v) {
        _vm.$set(_vm.createRateAdjustment, "transactionDate", $$v)
      },
      expression: "createRateAdjustment.transactionDate"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": "Pembayaran"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "Select",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.createRateAdjustment.containerSelected),
      callback: function($$v) {
        _vm.$set(_vm.createRateAdjustment, "containerSelected", $$v)
      },
      expression: "createRateAdjustment.containerSelected"
    }
  }, _vm._l((_vm.createRateAdjustment.containers), function(container) {
    return _c('Option', {
      key: container.receivableId,
      attrs: {
        "value": container.receivableId
      }
    }, [_vm._v(_vm._s(container.labelContainer))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": "Jumlah"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.createRateAdjustment.amount),
      callback: function($$v) {
        _vm.$set(_vm.createRateAdjustment, "amount", $$v)
      },
      expression: "createRateAdjustment.amount"
    }
  }, 'money', _vm.moneyFloat, false))], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingCreateRateAdjustment
    },
    on: {
      "click": _vm.postCreateRateAdjustment
    }
  }, [(!_vm.loadingCreateRateAdjustment) ? _c('span', [_vm._v("Simpan")]) : _c('span', [_vm._v("Wait.....")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09e449f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/receivable/ReceivableCutOffList.vue
// module id = 1775
// module chunks = 1